@let widget =
  widgetsEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();

@if (widget) {
  @let widgetTitle = widgetTitleSg();
  @let isLoading = loading();
  @let isCreating =
    widgetsEc.plugins.currentEntityPlugin.feature.selectors
      .isCreating()
      .asSignal();

  <atn-ds-centered-overlay type="full-width">
    <div class="atn-mosaic-dev-widget-dialog">
      <atn-ds-widget [title]="widgetTitle">
        <ng-container actions>
          <i
            class="atn-icon atn-run atn-blue"
            (click)="runQuery('RunButton.Clicked')"
          ></i>
          <i
            class="atn-icon atn-close atn-red"
            (click)="cancelClickHandler()"
          ></i>
        </ng-container>

        <div class="atn-mosaic-dev-widget-dialog__body">
          <atn-ds-integrated-horizontal-tabs>
            <ng-template
              atnDsTab
              name="General"
            >
              <atn-mosaic-dev-widget-general-tab />
            </ng-template>
            <ng-template
              atnDsTab
              name="Variables"
            >
              <atn-variables-builder />
            </ng-template>
          </atn-ds-integrated-horizontal-tabs>
        </div>

        <div
          footer
          class="atn-mosaic-dev-widget-dialog__footer"
        >
          <atn-ds-button
            type="transparent"
            (click)="cancelClickHandler()"
            [disabled]="isLoading"
            >Cancel</atn-ds-button
          >
          <atn-ds-button
            (click)="saveClickHandler()"
            [disabled]="isLoading"
            >{{ isCreating ? 'Create' : 'Update' }}</atn-ds-button
          >
        </div>
      </atn-ds-widget>

      @if (isLoading) {
        <atn-ds-loader
          [message]="isCreating ? 'Updating Widget...' : 'Creating Widget...'"
        />
      }
    </div>
  </atn-ds-centered-overlay>
}
